import { render, staticRenderFns } from "./file-info-query.vue?vue&type=template&id=5abb4638"
import script from "./file-info-query.vue?vue&type=script&lang=ts"
export * from "./file-info-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports